<div [ngClass]="(mobile)?'container is-fluid':'container'">
  <app-notification *ngIf="this.errorMsg != null" [content]="this.errorMsg" timeOut="0" display="true" isChildElement="true"
                    error=true data-testid="error-notification"></app-notification>
</div>


<div class="info__box">
  <img class="bookmark" alt="docestate bookmark" src="assets/images/messagebox/bookmark.jpg"/>
  <div class="info__box__head">
    <span>Hinweis</span>
  </div>
  <div class="info__box__body">
    <p>Bitte überprüfen Sie die eingetragenen Daten auf Richtigkeit und passen Sie diese bei Bedarf an.<br>
    </p>
    <p>Sollten Sie Unterschrift berechtigt sein können Sie unten im Signaturfeld direkt unterschreiben.</p>
    <br>
    <p>Alternativ klicken sie auf "PDF herunterladen" - Sie können sich die PDF speichern oder ausdrucken und später unterschrieben hochladen.</p>
  </div>
</div>
<h1 class="title has-text-centered is-bold">VOLLMACHT</h1>

<p>Das Unternehmen</p>
<div>
  <textarea id="company" cols="95" rows="5" class="editable">{{authorityData.company}}</textarea>
</div>
<p>vertreten durch</p>
<div>
  <textarea id="company-person" cols="95" rows="5" class="editable">{{authorityData.person}}</textarea>
</div>
<p>ist Eigentümer/in der in beigefügter Anlage 1 gelisteten Liegschaften.</p>
<p>Das Unternehmen erteilt der</p>
<p style="text-align: center"><strong> DocEstate GmbH <br> c/o Digitales Gründerzentrum<br>Werkstraße
  2
  <br/>63739 Aschaffenburg <br> einschließlich sämtlicher Geschäftsstandorte(Bonn, Frankfurt) und deren Angestellte <br> </strong></p>
<p>Vollmacht zur Anforderung sowie Einsicht sämtlicher Unterlagen, der für den/die
  Belegenheitsort/e aus Anlage 1 genannten Liegenschaften zuständigen Ämtern, Behörden,
  Kataster und Archiven. Konkret kann es sich hierbei um folgende Auszüge, Auskünfte und
  Dokumente handeln: <em>Altlasten, Baulasten, Grundbuch, Denkmalschutz, Liegenschaftskataster,
    planungsrechtliche und städtebauliche Belange, Bebauungsplan, Vorkaufsrecht,
    Kampfmittelauskunft,
    Auskünfte zu Erschließungsbeiträgen (Anliegerbescheinigung), Erschließungsvertrag,
    Städtebaulicher
    Vertrag, Grenzbescheinigung.</em></p>
<p>Die Aufzählung ist jedoch nicht abschließend oder begrenzt und umfasst alle weiteren behördlichen
  Auskünfte im Zusammenhang der genannten Liegenschaften.</p>
<p>Die Untervollmacht umfasst zudem die Befugnis, Kopien anzufertigen bzw. Kopien anzufordern.</p>
<p>Des Weiteren wird eingewilligt, dass die benötigten personenbezogenen Daten von der DocEstate
  GmbH zum
  Zweck des Nachweises einer Berechtigung zur Einsicht in die Grundakte bzw. öffentliche
  Verzeichnisse und
  Register erhoben, verarbeitet und genutzt werden dürfen. </p>
<p>Die Vollmacht ist zeitlich</p>
<div [ngClass]="(mobile)?'select-wrapper-mobile':'select-wrapper'">
  <select id="dauer" [ngClass]="(mobile)?'dropdown is-lightblue select-mobile ':'dropdown is-lightblue'">
    <option [selected]="authorityData.dauer === 'unbefriestet'" selected>unbefristet</option>
    <option [selected]="authorityData.dauer === 'auf sechs Monate ab Ausstellungsdatum befristet.'">auf sechs Monate ab Ausstellungsdatum befristet.</option>
  </select>
</div>
<br>
<div class="columns">
  <div class="column is-4">
    <div class="container" style="position: relative">
      <span></span>
      <label>
        Ort/Datum der Ausstellung:
        <input id="signing-date-input" type="text" class="editable input is-focused is-warning" value="{{authorityData.signingDate}}"/>
      </label>
    </div>
  </div>
  <div class="column">
    <app-signature-pad ></app-signature-pad>
  </div>
</div>

<div style="clear: both;margin-bottom: 5em"></div>
<h1 style="page-break-before:always;">Anlage 1</h1>
<table class="table">
  <thead>
  <th scope="col">Lfd. Nr.</th>
  <th scope="col">Adresse</th>
  <th scope="col">Gemarkung</th>
  <th scope="col">Grundbuchblatt</th>
  </thead>
  <tbody>
  <ng-container *ngFor="let property of properties; index as i">
    <tr *ngFor="let landregisterfolios of property.landregisterfolios">
      <td>{{i+1}}</td>
      <td>{{property.street}}, {{property.zip}} {{property.town}}</td>
      <td>{{landregisterfolios.gemarkung}}</td>
      <td>{{landregisterfolios.number}}</td>
    </tr>
  </ng-container>
  </tbody>
</table>
